// complianceMath.js

// Helper: Checks if a date is Saturday (6) or Sunday (0)
const isWeekend = (date) => {
  const day = date.getDay();
  return day === 0 || day === 6;
};

// Helper: Checks if a date string is in the explicitly clicked holidays array
const isHoliday = (dateString, holidaysArray) => {
  return holidaysArray.includes(dateString);
};

// --- Summer Break Detection ---
const isSummerBreak = (dateString, boundaries) => {
  // If we don't have boundaries loaded, fail safe to false
  if (!boundaries || Object.keys(boundaries).length === 0) return false;

  // Check if the date is INSIDE any active school year
  let isInsideActiveYear = false;
  for (const year in boundaries) {
    const { startDate, endDate } = boundaries[year];
    if (dateString >= startDate && dateString <= endDate) {
      isInsideActiveYear = true;
      break;
    }
  }

  // If it is NOT inside any active school year, it's summer break!
  return !isInsideActiveYear;
};

/**
 * Calculates a FORWARD deadline (e.g., 60 days to complete an evaluation)
 */
export const calculateDeadline = (startDateString, schoolDaysToAdd, holidaysArray = [], boundaries = {}) => {
  if (!startDateString) return '';

  const [year, month, day] = startDateString.split('-');
  let currentDate = new Date(year, month - 1, day, 0, 0, 0); 
  
  let daysAdded = 0;

  // Keep looping until we've added the required number of school days
  while (daysAdded < schoolDaysToAdd) {
    currentDate.setDate(currentDate.getDate() + 1);
    
    const localMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
    const localDay = String(currentDate.getDate()).padStart(2, '0');
    const localYear = currentDate.getFullYear();
    const formattedDate = `${localYear}-${localMonth}-${localDay}`;

    if (!isWeekend(currentDate) && !isHoliday(formattedDate, holidaysArray) && !isSummerBreak(formattedDate, boundaries)) {
      daysAdded++;
    }
  }

  const finalMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
  const finalDay = String(currentDate.getDate()).padStart(2, '0');
  const finalYear = currentDate.getFullYear();

  return `${finalYear}-${finalMonth}-${finalDay}`;
};

/**
 * Calculates a BACKWARD countdown (e.g., 80 days before Re-Eval is due)
 */
export const calculateCountdown = (endDateString, schoolDaysToSubtract, holidaysArray = [], boundaries = {}) => {
  if (!endDateString) return '';

  const [year, month, day] = endDateString.split('-');
  let currentDate = new Date(year, month - 1, day, 0, 0, 0); 
  
  let daysSubtracted = 0;

  // Keep looping backward until we've subtracted the required number of school days
  while (daysSubtracted < schoolDaysToSubtract) {
    currentDate.setDate(currentDate.getDate() - 1); 
    
    const localMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
    const localDay = String(currentDate.getDate()).padStart(2, '0');
    const localYear = currentDate.getFullYear();
    const formattedDate = `${localYear}-${localMonth}-${localDay}`;

    if (!isWeekend(currentDate) && !isHoliday(formattedDate, holidaysArray) && !isSummerBreak(formattedDate, boundaries)) {
      daysSubtracted++;
    }
  }

  const finalMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
  const finalDay = String(currentDate.getDate()).padStart(2, '0');
  const finalYear = currentDate.getFullYear();

  return `${finalYear}-${finalMonth}-${finalDay}`;
};